<template>
    <div class="DM_attainRecord">
        <!-- 表单搜索部分 -->
        <el-card class="box-card" shadow="hover">
            <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                <el-form-item style="width:187px;">
                    <el-radio v-model="searchForm.type" :label="1" @change="typeChange">团队</el-radio>
                    <el-radio v-model="searchForm.type" :label="2" @change="typeChange">直营</el-radio>
                </el-form-item>
                <el-form-item>
                    <el-select
                        v-model="searchForm.brand_id"
                        filterable
                        clearable
                        style="width:100%"
                        placeholder="请选择终端类型"
                    >
                        <el-option
                            v-for="(item,index) in brandList"
                            :key="index"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input size clearable v-model="searchForm.terminal_sn" placeholder="请输入终端SN"></el-input>
                </el-form-item>
                <el-form-item v-if="level == 0||level == 1">
                    <el-input size clearable v-model="searchForm.phone" placeholder="请输入归属代理账号"></el-input>
                </el-form-item>
              <el-form-item v-if="level == 0||level == 1">
                <el-input size clearable v-model="searchForm.agent_no" placeholder="请输入归属代理编号"></el-input>
              </el-form-item>
                <!-- <el-form-item v-if="level == 0||level == 1">
                    <el-input size clearable v-model="searchForm.name" placeholder="请输入归属代理名称"></el-input>
                </el-form-item> -->
                <el-form-item>
                    <el-date-picker
                        v-model="rangeDate"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions"
                        @change="pickerChange"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button
                        size="medium"
                        type="primary"
                        icon="el-icon-search"
                        style="font-size: 12px;"
                        @click="onSearch(searchForm)"
                    >查询</el-button>
                    <el-button
                        size="small"
                        type="primary"
                        icon="el-icon-download"
                        :loading="downLoading"
                        @click="handleDownLoad(searchForm)"
                    >导出数据</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
            <el-table :data="recordList" size="mini" border style="width: 100%" v-loading="loading">
                <!-- ID -->
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed
                    type="index"
                    label="ID"
                    min-width="80"
                ></el-table-column>
                <!-- 终端类型 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="brand_name"
                    label="终端类型"
                    min-width="120"
                ></el-table-column>
                <!-- 终端SN -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="terminal_sn"
                    label="终端SN"
                    min-width="120"
                ></el-table-column>
                <!-- 终端归属代理名称 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="name"
                    label="终端归属代理名称"
                    min-width="120"
                    v-if="level == 0||level == 1"
                ></el-table-column>
                <!-- 终端归属代理账号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="phone"
                    label="终端归属代理账号"
                    min-width="120"
                    v-if="level == 0||level == 1"
                >
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.phone | desMobile" placement="top">
                      <p>{{ scope.row.phone | desMobile }}</p>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <!-- 终端归属代理编号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="agent_no"
                    label="终端归属代理编号"
                    min-width="150"
                    v-if="level == 0||level == 1"
                >
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.agent_no" placement="top">
                      <p>{{ scope.row.agent_no | desMobile }}</p>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <!-- 达标规则 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="rule"
                    label="达标规则"
                    min-width="120"
                    show-overflow-tooltip
                ></el-table-column>
                <!-- 达标时间 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="award_time"
                    label="达标时间"
                    min-width="150"
                ></el-table-column>
                <!-- 达标奖励金额 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="reward_money"
                    label="达标奖励金额"
                    min-width="150"
                ></el-table-column>
                <!-- 操作 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed="right"
                    label="操作"
                    min-width="150"
                >
                    <template slot-scope="scope">
                        <el-button @click="handleInfo(scope.row)" type="text" size="small">详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页部分 -->
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[10,20,50,100]"
                :current-page="currentPage"
                :page-size="pageSize"
                :total="total"
                layout="total, sizes, prev, pager, next, jumper"
            ></el-pagination>
        </el-card>
        <record-info
            v-if="infoIsShow"
            :infoIsShow="infoIsShow"
            :detail="detail"
            @infoClose="handleInfoClose"
        ></record-info>
    </div>
</template>
<script>
import recordInfo from './DM_attainRecordInfo';
export default {
    name: "DM_attainRecord",
    data() {
        return {
            infoIsShow: false,
            detail: {},
            searchForm: {
                page: 1,
                limit: 10,
                type: 1,
                brand_id: '',
                terminal_sn: '',
                name: '',
                phone: '',
                agent_no: '',
                start_time: '',
                end_time: ''
            },
            currentDate: '',
            pickerOptions: {},
            rangeDate: [], //时间范围
            brandList: [],
            recordList: [],
            currentPage: 1, //当前页码
            pageSize: 10, //条数
            total: 0,  //总数
            loading: true,
            downLoading: false, //导出loading
            level: sessionStorage.getItem('level')
        }
    },
    components: {
        recordInfo
    },
    created() {
        this.pickerOptions.disabledDate = (time) => { //禁用日期
            if (this.currentDate !== '') {
                let tempTime = 3600 * 1000 * 24 * 30 * 3;
                let timer = new Date(this.currentDate).getTime();
                let minTime = timer - tempTime;
                let maxTime = timer + tempTime;
                return time.getTime() < minTime || time.getTime() > Date.now() || time.getTime() > maxTime;
            }
            return time.getTime() > Date.now();
        }
        this.pickerOptions.onPick = ({ minDate, maxDate }) => { //当前选中的日期
            this.currentDate = minDate.getTime();
            if (maxDate) {
                this.currentDate = '';
            }
        }
    },
    mounted() {
        this.handleDefaultTime();
        this.$api.post('brand/brand_list', {}, res => { //获取终端类型
            if (res.code == 0) {
                this.brandList = res.data.list;
            } else {
                this.$$message.success(res.msg);
            }
        });
        this.getData(this.searchForm)
    },
    methods: {
        typeChange(val) { //监听radio
            this.searchForm.type = val;
            this.searchForm.page = 1; //重置
            // 表单提交
            this.getData(this.searchForm);
        },
        onSearch(searchForm) {
            this.currentPage = 1;
            searchForm.page = 1;
            this.getData(searchForm);
        },
        getData(params) { //获取数据
            this.loading = true;
            this.$api.post("transaction/standard_award", params, res => {
                let data = res.data;
                this.total = data.count; //总数
                this.recordList = res.data.list;
                //渲染结束后取消加载
                this.loading = false;
            })
        },
        handleInfo(row) { //详情
            this.infoIsShow = true;
            this.detail = row;
        },
        handleInfoClose() { //关闭详情
            this.infoIsShow = false;
        },
        handleCurrentChange(page) { //当前选中页
            this.currentPage = page;
            this.searchForm.page = page;
            this.searchForm.limit = this.pageSize;
            this.getData(this.searchForm);
        },
        handleSizeChange(limit) { //条数
            this.currentPage = 1;
            this.pageSize = limit;
            this.searchForm.page = 1;
            this.searchForm.limit = limit;
            this.getData(this.searchForm);
        },
        handleDownLoad(searchForm) { //导出
			let reqData = {
				type: 9,
				value: JSON.stringify(searchForm)
			};
			
			this.downLoading = true; 
			this.$api.post('export/add', reqData, res => {
				if (res.code == 0) {
					this.$message.success(res.msg);
					this.downLoading = false;
				} else {
					this.$message.error(res.msg);
					this.downLoading = false;
				}
			})
            // this.downLoading = true;
            // this.$api.post("transaction/standard_award_download", searchForm, res => {
            //     if (res.code == 0) {
            //         this.$message.success(res.msg);
            //         var link=this.$file_url+res.data;
            //         window.open(link)
            //     } else {
            //         this.$message.error(res.msg);
            //     }
            //     //渲染结束后取消加载
            //     this.downLoading = false;
            // })
        },
        handleDefaultTime() { //默认获取三十天
            let date =this.$moment().endOf('day').format('x');
            this.searchForm.end_time = this.$moment(Number(date)).format("YYYY-MM-DD HH:mm:ss");
            this.searchForm.start_time = this.$moment(Number(date) - 3600 * 1000 * 24 * 31 +1).format("YYYY-MM-DD HH:mm:ss");
            this.rangeDate = [this.searchForm.start_time, this.searchForm.end_time];
        },
        pickerChange(DateArr) { //时间选择器
            this.searchForm.start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
            this.searchForm.end_time = this._.isEmpty(DateArr) ? '' : this.$moment(Number(this.$moment(DateArr[1]).endOf('day').format('x'))).format("YYYY-MM-DD HH:mm:ss");
            console.log(this.searchForm.end_time)
            this.rangeDate = [this.searchForm.start_time, this.searchForm.end_time];
        },
    }
}
</script>

<style scoped lang="scss">
.DM_attainRecord {
    .el-input__inner {
        font-size: 12px;
    }
    .el-form-item {
        margin-bottom: 5px;
    }
}
</style>